import React from 'react'
import { Typography } from '@material-tailwind/react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import pkgInfo from '../../package.json'

const Footer: React.FC = () => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()
  return (
    <div className="w-full px-4 md:px-16 z-50 text-white-yellow dark:bg-primary">
      <div className="border-t border-white-yellow flex flex-col md:flex-row justify-between items-center py-10">
        <div className="md:space-x-12 flex flex-col md:flex-row pb-10 md:pb-0 w-full">
          <Link className="opacity-90 hover:opacity-100 pb-2 md:pb-0" to="/about">
            {t('footer.about')}
          </Link>
          <Link className="opacity-90 hover:opacity-100 pb-2 md:pb-0" to="/how-it-works">
            {t('footer.howItWorks')}
          </Link>
          <Link className="opacity-90 hover:opacity-100 pb-2 md:pb-0" to="/faq">
            {t('footer.faq')}
          </Link>
          <Link className="opacity-90 hover:opacity-100 pb-2 md:pb-0" to="/support">
            {t('footer.support')}
          </Link>
          <Link className="opacity-90 hover:opacity-100" to="/privacy-policy">
            {t('footer.privacyPolicy')}
          </Link>
        </div>
        <Typography variant="small" className="whitespace-nowrap">
          {t('footer.copyright', { year: currentYear, version: pkgInfo.version })}
        </Typography>
      </div>
    </div>
  )
}

export default Footer
